import React from 'react'

const Footer = () => {
    return (
        <p style={{ backgroundColor: 'navy', color: 'white', textAlign: 'end', height: '1.5rem', position: 'sticky', bottom: 0 }}>
            Copyright © 2024 Carrier. All rights reserved.
        </p>
    )
}

export default Footer
